module.exports = __webpack_public_path__ + "img/tjfoot4.300cb3f6.jpg";